<app-table
  *ngIf="cols && products"
  [cols]="cols"
  [elements]="products"
  modelName="Estoque"
  sortField="productVariantName"
  [sortOrder]="-1"
  [lazy]="false"
  [dropdownFilters]="dropdownFilters"
  [showFooter]="true"
  [footerTemplate]="footerTemplate"
  [addButton]="false"
  [showFooter]="true"
  [changeColumns]="true"
  (columnsChanged)="changeColumns($event)"
>
  <ng-template #footerTemplate>
    <tr *ngIf="columnsDiplayed">
      <td [attr.colspan]="columnsDiplayed?.length - 6">Total</td>
      <td class="text-right">{{ totalAcquisiton | number : '1.0-0' }}</td>
      <td class="text-right danger">
        {{ totalReservedAcquisiton | number : '1.0-0' }}
      </td>
      <td class="text-right">{{ totalFidelization | number : '1.0-0' }}</td>
      <td class="text-right danger">
        {{ totalReservedFidelization | number : '1.0-0' }}
      </td>
      <td class="text-right">{{ totalReserveMarketing | number : '1.0-0' }}</td>
      <td class="text-right">{{ totalInfluencer | number : '1.0-0' }}</td>
    </tr>
  </ng-template>
</app-table>
